module.exports = __webpack_public_path__ + "static/terms-of-service-a413d5b3e3f34bd8d9c0ce815d471490.jpg";